import * as React from 'react';

interface Props {
  mainUrl: string;
  previewUrl?: string;
  isEdited: boolean;
}

export function SchoolAppSchoolJobImageSummary({ mainUrl, previewUrl, isEdited }: Props) {
  const width = isEdited ? '60%' : '100%';
  const margin = isEdited ? '0 auto' : '0';

  const imgStyle: React.CSSProperties = {
    display: 'block',
    width,
    margin,
    padding: 0,
  };

  return (
    <>
      <img src={mainUrl} alt="Main" className="img-fluid img-thumbnail" style={imgStyle} />
      {previewUrl && <img src={previewUrl} alt="Preview" className="img-fluid img-thumbnail" style={imgStyle} />}
    </>
  );
}
